<div [formGroup]="form">
  <div
    style="margin-bottom: 0.5rem"
    *ngFor="let pet of petTileList$ | async; let i = index"
  >
    <app-reservation-pet-tile-form
      #ptForm
      [form]="petFormArray.controls[i]"
      [petInfo]="petList[i]"
      [isErrorOnSave]="isErrorOnSave"
    ></app-reservation-pet-tile-form>
  </div>
  <div class="pet-info-label">Please note:</div>
  <div class="interview-request-content">
    Don’t see your pup listed here? If your dog hasn't completed their Camper
    Interview, they will not be available here for reservations.
  </div>
  <div style="margin-top: 2.5rem">
    <hr />
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onSave()"
        [disabled]="!isSaveEnabled"
      >
        Continue
      </button>
    </footer>
  </div>
</div>
